export const ALL_APPS = 'All Apps';

export const DASHBOARD_PATH = '/pages/dashboard';
export const APPS_PATH = '/pages/apps';
export const CREATE_APP_PATH = '/pages/apps/create';
export const SIGNUP_PATH = '/signup';
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const RESET_PASSWORD_PATH = '/reset-password';
export const UPDATE_PASSWORD_PATH = '/update-password';
export const CONFIRMATION_PATH = '/confirm';

const RESOURCE_PATH = '/pages/resources';
export const RESOURCES_PATHS = {
  common: RESOURCE_PATH,
  route: RESOURCE_PATH + '/:type',
  sdk: RESOURCE_PATH + '/sdk',
  api: RESOURCE_PATH + '/api'
};

const CREATE_MAGAZINE_PATH = '/pages/create';
export const CREATE_MAGAZINE_PATHS = {
  common: CREATE_MAGAZINE_PATH,
  route: CREATE_MAGAZINE_PATH + '/:type',
  picked: CREATE_MAGAZINE_PATH + '/picked-magazine',
  instant: CREATE_MAGAZINE_PATH + '/instant-magazine'
};



// WEBPACK FOOTER //
// ./src/utils/constants.js